<template>
  <el-row
    class="unex-search-grid-group"
    :gutter="gutter"
    :type="type"
    :justify="justify"
    :align="align"
    :tag="tag"
  >
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  props: {
    gutter: {
      default: 16
    },
    type: {},
    justify: {},
    align: {},
    tag: {}
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {}
};
</script>

<style lang="less">
.el-form--label-top {
  .unex-search-grid-group {
    .el-col {
      .el-form-item {
        margin-bottom: 16px;
        .el-form-item__label {
          line-height: 18px;
          font-size: 14px;
          padding: 0px 0px 4px 0px;
          display: block;
        }
        .el-form-item__content {
          line-height: 32px;
        }
      }
    }
  }
}
</style>
